module.exports = __webpack_public_path__ + "media/join.8cc99027.mp3";